/**
 * `'serviceWorker' in navigator` is a runtime check, not a type assertion: jsdom and older browsers
 * simply omit the property, even though `Navigator` declares it as always present.
 */
const resolveServiceWorkerContainer = (): ServiceWorkerContainer | undefined => {
	return 'serviceWorker' in navigator ? navigator.serviceWorker : undefined;
};

export default resolveServiceWorkerContainer;
